export const CANCEL_QUICK_LINK_MODAL_STEP_STATUS = {
  SUCCESS: 'success',
  FAILED: 'failed',
  START: 'start',
} as const;

export const LINK_STATES = {
  DEACTIVATED: 'deactivated',
  PAID: 'paid',
  UNPAID: 'unpaid',
  CANCELLED: 'canceled'
} as const;
